import * as React from "react"

import type {
  AlfredBulkImportProgressJob,
  AlfredBulkImportUploadResult,
} from "@/types/alfred-bulk-import"

export const ALFRED_BULK_IMPORT_JOB_ID_STORAGE_KEY = "alfredBulkImportJobId"
export const ALFRED_BULK_IMPORT_NOTIFIED_JOB_ID_STORAGE_KEY =
  "alfredBulkImportNotifiedJobId"

export interface AlfredBulkImportJobContextValue {
  jobId: string | null
  job?: AlfredBulkImportProgressJob
  error?: unknown
  isLoading: boolean
  startJob: (result: AlfredBulkImportUploadResult) => void
  dismissJob: () => void
}

export const AlfredBulkImportJobContext =
  React.createContext<AlfredBulkImportJobContextValue | null>(null)

export function useAlfredBulkImportJobContext(): AlfredBulkImportJobContextValue {
  const context = React.useContext(AlfredBulkImportJobContext)
  if (!context) {
    throw new Error("useAlfredBulkImportJobContext must be used inside AlfredBulkImportJobProvider")
  }
  return context
}
